import { Fragment } from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router';
import JumpDetails from '@/components/JumpDetails';
import JumpTeam from '@/components/JumpTeam';
import Authorized from '@/components/Authorized';

const route = '/pubsubmission/$submissionId';
export const Route = createFileRoute(route)({
  component: PubSubmissionPage,
})

function PubSubmissionPage() {
    const { submissionId } = useParams({ from: route });
    const scrollViewStyles = {
      height: "100%"
    }

    return (
      <Fragment>
        <Authorized>
            <div className="scrolling-container" style={scrollViewStyles}>
              <div className="outer-container">
                  <JumpDetails jumpId={submissionId} />
                  <JumpTeam jumpId={submissionId} />
              </div>
            </div>
        </Authorized>
      </Fragment>
    )
}
